<template>
  <router-view />
</template>

<script>
  export default {
    name: "CooperativeSetQuery",
  };
</script>